import React, { Component } from "react";
import "containers/Template/Header/Desktop/Settings.css";
import { connect } from "react-redux";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as CONSTANT from "constants/text";

class Settings extends Component {
  render() {
    return (
      <div className="header__settings menu-settings">
        <div className="setting-icon">
          <FontAwesomeIcon icon={faCog} color="#A2C4C6" size="lg" />
          <div className="settings-dropdown">
            <a href="/account">
              <div className="settings-dropdown__item">My&nbsp;Account</div>
            </a>
            <a href="/blocked-users" >
              <div className="settings-dropdown__item">Blocked&nbsp;Users</div>
            </a>
            <a href="/payments">
              <div className="settings-dropdown__item">Payments</div>
            </a>
            <a href="/terms-and-conditions">
              <div className="settings-dropdown__item">
              {CONSTANT.T_AND_C}
              </div>
            </a>
            <a href="/security-and-privacy">
              <div className="settings-dropdown__item">
                Security&nbsp;and&nbsp;Privacy
              </div>
            </a>
            {/* <a href="/content-creation-suite">
              <div className="settings-dropdown__item">
                Content&nbsp;Creation&nbsp;Suite
              </div>
            </a> */}
            <a href="/logout" className="logout-link">
              <div className="settings-dropdown__item">Logout</div>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Settings);
